/**
 * Runs `task` now and again `intervalMs` after each run settles, so a slow
 * run never overlaps the next one the way a fixed setInterval does. A run
 * that throws is logged and does not stop the polling. Returns a function
 * that stops it; a run already in flight finishes but does not schedule
 * another.
 */
export function startPolling(task, intervalMs) {
  let stopped = false;
  let timer = null;

  const run = async () => {
    try {
      await task();
    } catch (error) {
      console.error("Polling task failed:", error);
    } finally {
      if (!stopped) timer = setTimeout(run, intervalMs);
    }
  };
  run();

  return () => {
    stopped = true;
    clearTimeout(timer);
  };
}
